var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4224 0.00292969C4.90236 0.00292969 0.422363 4.48293 0.422363 10.0029C0.422363 15.5229 4.90236 20.0029 10.4224 20.0029C15.9424 20.0029 20.4224 15.5229 20.4224 10.0029C20.4224 4.48293 15.9424 0.00292969 10.4224 0.00292969ZM16.4224 11.9729H11.4224L13.6824 9.71293C12.7724 8.65293 11.4324 7.97293 9.92236 7.97293C7.55236 7.97293 5.57236 9.63293 5.06236 11.8529L4.10236 11.5329C4.74236 8.91293 7.10236 6.97293 9.92236 6.97293C11.7024 6.97293 13.2924 7.76293 14.3924 9.00293L16.4224 6.97293V11.9729Z",
    fill: "#2958DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextplan);
export default __webpack_public_path__ + "static/media/nextplan.b65ffba5f8a0b6742d275440ca37de76.svg";
export { ForwardRef as ReactComponent };